import React from "react";
import Lottie from "lottie-react";
import AnimationData from "../../assets/PeopleLottie.json";

const InValidLottie = ({ text }) => {
  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-8 gap-8 justify-center items-center">
      <Lottie animationData={AnimationData} />
      <div
        className="text-[#130C40] lg:text-3xl md:text-xl text-lg font-bold mt-10 lg:mb-0 mb-[60px] w-full text-center"
        style={{ fontFamily: "DM Sans" }}
      >
        {text}
      </div>
    </div>
  );
};

export default InValidLottie;
